import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const breadcrumbDefinition: ComponentDefinition = {
  id: 'breadcrumb-experience',
  name: 'Breadcrumb',
  category: 'UI',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/chevrons-right.svg',
  variables: {
    // label: {
    //   displayName: 'Label',
    //   type: 'Text',
    //   defaultValue: '#',
    // },
    // href: {
    //   displayName: 'Link',
    //   type: 'Text',
    //   defaultValue: '#',
    // },
    // withArrow: {
    //   displayName: 'With Arrow',
    //   type: 'Boolean',
    //   defaultValue: false,
    // },
  },
} as const;
